import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'
import {
  CreateMessagePayload,
  CreateMessageResponse,
  MessageAction,
  MessageResponse,
} from '../definitions'

const URL = '/chat-bot'

const getMessages = (config?: AxiosRequestConfig): Promise<MessageResponse> => {
  return RequestBase.get(URL, config)
}

const createMessage = (data: CreateMessagePayload): Promise<CreateMessageResponse> => {
  return RequestBase.post(URL, data)
}

const clearChatHistory = () => {
  return RequestBase.remove(`${URL}/delete`)
}
const checkMessage = (id: string | number) => {
  return RequestBase.get(`${URL}/${id}/check`)
}

const updateAction = (id: string | number, action: MessageAction | null) => {
  return RequestBase.patch(`${URL}/${id}/action`, {action})
}

const ChatbotService = {
  getMessages,
  createMessage,
  clearChatHistory,
  checkMessage,
  updateAction,
}
export default ChatbotService
